<div class="share-modal">
  <div class="share-modal__header">
    <div class="share-modal__title">
      <img [src]="'/svg/share-arrow.svg' | assetVersion" width="16" height="16" alt="" />
      <span>Share chat</span>
    </div>
    <button class="share-modal__close" (click)="close()" aria-label="Close">
      <img [src]="'/svg/closeX-grey.svg' | assetVersion" width="15" height="15" alt="" />
    </button>
  </div>

  <p class="share-modal__subtitle">Let your colleagues view this chat and continue the analysis themselves.</p>

  <div class="share-modal__url-row">
    <span class="share-modal__url">{{ displayUrl }}</span>
    @if (copied) {
      <span class="share-modal__copied">
        <img [src]="'/svg/checkmark.svg' | assetVersion" width="12" height="8" alt="" />Copied
      </span>
    } @else {
      <button class="share-modal__copy" (click)="copyLink()">Copy link</button>
    }
  </div>

  <div class="share-modal__info">
    <img [src]="'/svg/info.svg' | assetVersion" width="15" height="15" alt="" />
    <span>Anyone with this link from <strong>{{ accountName }}</strong> can view this chat.</span>
  </div>
</div>
